import React from 'react';
import { roles } from '@nxsys/store/constants';

const ActivityLogs = React.lazy(() => import('../../../modules/activityLogs'));

export const activityLogsConfig = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/activity-log',
    element: <ActivityLogs />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/activity-log/:activeTab',
    element: <ActivityLogs />,
  },
];
